import { render, staticRenderFns } from "./adjust-record-dialog.vue?vue&type=template&id=1515385e&scoped=true&"
import script from "./adjust-record-dialog.vue?vue&type=script&lang=js&"
export * from "./adjust-record-dialog.vue?vue&type=script&lang=js&"
import style0 from "./adjust-record-dialog.vue?vue&type=style&index=0&id=1515385e&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1515385e",
  null
  
)

export default component.exports